import React from 'react'

import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import Separator from '../../../../../components/pdf/Separator'
import View from '../../../../../components/pdf/View'
import Line from '../../../../../components/pdf/Line'
import Text from '../../../../../components/pdf/Text'

const Identifications = ({ data }) => {
  return (
    <View pageBreakAfter style={{ minHeight: '27cm', display: 'flex', flexDirection: 'column' }}>
      <Line height={3} color="#333" />

      <Separator weight={1} />
      <Text size={30} bold>
        Identificação da empresa
      </Text>

      <Separator weight={8} />

      <Table width={'100%'} useFontBaseColor>
        <TableRow useFontBaseColor>
          <TableCol width={'50%'} useFontBaseColor>
            <Text bold>Data de elaboração:</Text>
          </TableCol>
          <TableCol style={{ borderLeft: 0 }} useFontBaseColor>
            <Text bold>{data.formatCompletedDate}</Text>
          </TableCol>
        </TableRow>
      </Table>

      <Separator weight={8} />

      <Text bold size={22}>
        {data.place}
      </Text>
      <Text>{data.place}</Text>
      <Text>{data.CNPJ}</Text>
      <Text>-</Text>

      <Separator weight={8} />

      <Text bold size={22}>
        Endereço
      </Text>
      <Text>{data.address}</Text>
      <Text>-</Text>

      <Separator weight={8} />

      <Text bold size={22}>
        CNAE
      </Text>
      <Text>{data.CNAE}</Text>
      <Text>-</Text>

      <Separator weight={8} />

      <Line color={'#333'} height={3} />

      <Separator weight={1} />
      <Text size={30} bold>
        Identificação do avaliador
      </Text>

      <Separator weight={8} />

      <Table useFontBaseColor width={'100%'}>
        <TableRow useFontBaseColor>
          <TableCol width={'50%'} useFontBaseColor>
            <Text align={'center'}>Avaliador</Text>
          </TableCol>
          <TableCol width={'50%'} useFontBaseColor>
            <Text align={'center'}>Celina de Andrade Marques Gil</Text>
            <Text align={'center'}>Fisioterapeuta - Crefito-3/20349-F</Text>
            <Text align={'center'}>Consultora em Ergonomia</Text>
          </TableCol>
        </TableRow>
      </Table>
    </View>
  )
}

export default Identifications
